import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IbexImageComponent } from './ibex-image/ibex-image.component';
import { ClockComponent } from './clock/clock.component';
import { CountdownComponent } from './countdown/countdown.component';
import { KeyboardComponent } from './keyboard/keyboard.component';
import { LineClampComponent } from './line-clamp/line-clamp.component';
import { FormsModule } from '@angular/forms';
import { TilesComponent } from './tiles/tiles.component';
import { CarouselModule } from './carousel/carousel.module';
import { MediaComponent } from './detail-view/media/media.component';
import { PdfComponent } from './pdf/pdf.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { IbexIconModule } from '@ibexfusion/ibex-icon';
import { BubbleIndicatorComponent } from "./bubble-indicator/bubble-indicator.component";
import { PipesModule } from '../pipes/pipes.module';
import { PersonCardComponent } from './apps/person/person-card/person-card.component';
import { ScrollListComponent } from './scroll-list/scroll-list.component';
import { DynamicScrollListComponent } from './dynamic-scroll-list/dynamic-scroll-list.component';
import { QrCodeComponent } from './qr-code/qr-code.component';
import { CinemaDetailComponent } from './detail-view/cinema-detail/cinema-detail.component';
import { BreakingNewsComponent } from './breaking-news/breaking-news.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { IbexVideoComponent } from './ibex-video/ibex-video.component';
import { MessagePopupComponent } from './popups/message-popup/message-popup.component';
import { LoaderComponent } from './loader/loader.component';
import { StarRatingComponent } from './star-rating/star-rating.component';
import { AirportDetailComponent } from './detail-view/airport-detail/airport-detail.component';
import { MapComponent } from './map/map.component';
import { MagnifyingGlassComponent } from './magnifying-glass/magnifying-glass.component';
import { SocialMediaDetail } from './detail-view/social-media-detail/sc-detail';
import { TodayOpeningHoursInfoComponent } from './detail-view/today-opening-hours-info/today-opening-hours-info.component';
import { SeasonTimesInfoComponent } from './detail-view/season-times-info/season-times-info.component';
import { OpeningHoursDetailComponent } from './detail-view/opening-hours-detail/opening-hours-detail.component';
import { StreetConditionsDetailComponent } from './detail-view/street-conditions-detail/street-conditions-detail.component';
import { SeasonTimesFilterComponent } from './season-times-filter/season-times-filter.component';
import { ScrollContainerComponent } from './scroll-container/scroll-container.component';
import { OpenFilterComponent } from './open-filter/open-filter.component';
import { IbexVideoLoopComponent } from './ibex-video-loop/ibex-video-loop.component';
import { GhosthandComponent } from './ghosthand/ghosthand.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { ProgressBarDetailComponent } from './progress-bar-detail/progress-bar-detail.component';
import { LineClampNewComponent } from './line-clamp-new/line-clamp-new.component';
import { WidgetCarouselModule } from './widget-carousel/widget-carousel.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CarouselModule,
    WidgetCarouselModule,
    PdfViewerModule,
    IbexIconModule,
    PipesModule,
    NgxExtendedPdfViewerModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    IbexImageComponent,
    ClockComponent,
    CountdownComponent,
    KeyboardComponent,
    LineClampComponent,
    LineClampNewComponent,
    TilesComponent,
    MediaComponent,
    PdfComponent,
    BubbleIndicatorComponent,
    PersonCardComponent,
    ScrollListComponent,
    DynamicScrollListComponent,
    QrCodeComponent,
    CinemaDetailComponent,
    BreakingNewsComponent,
    IbexVideoComponent,
    MessagePopupComponent,
    LoaderComponent,
    OpeningHoursDetailComponent,
    StarRatingComponent,
    AirportDetailComponent,
    MapComponent,
    MagnifyingGlassComponent,
    SocialMediaDetail,
    TodayOpeningHoursInfoComponent,
    SeasonTimesInfoComponent,
    StreetConditionsDetailComponent,
    SeasonTimesFilterComponent,
    OpenFilterComponent,
    ScrollContainerComponent,
    IbexVideoLoopComponent,
    GhosthandComponent,
    ProgressBarComponent,
    ProgressBarDetailComponent
  ],
  exports: [
    IbexImageComponent,
    ClockComponent,
    CountdownComponent,
    KeyboardComponent,
    LineClampComponent,
    LineClampNewComponent,
    TilesComponent,
    MediaComponent,
    PdfComponent,
    BubbleIndicatorComponent,
    PersonCardComponent,
    ScrollListComponent,
    DynamicScrollListComponent,
    QrCodeComponent,
    CinemaDetailComponent,
    BreakingNewsComponent,
    IbexVideoComponent,
    LoaderComponent,
    OpeningHoursDetailComponent,
    StarRatingComponent,
    AirportDetailComponent,
    MapComponent,
    MagnifyingGlassComponent,
    SocialMediaDetail,
    TodayOpeningHoursInfoComponent,
    SeasonTimesInfoComponent,
    StreetConditionsDetailComponent,
    SeasonTimesFilterComponent,
    OpenFilterComponent,
    ScrollContainerComponent,
    IbexVideoLoopComponent,
    GhosthandComponent,
    ProgressBarComponent,
    ProgressBarDetailComponent
  ]
})
export class GlobalComponentsModule {
}
